export default __webpack_public_path__ + "static/media/swansea.69decfa2.png";